import { cn } from "@newxsystems/shared";
import { TootActions } from "../../../layout/components/TootActions/TootActions";
import { TootHeading } from "../../../layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../layout/components/TootSectionShell/TootSectionShell";
import { TootMediaFrame } from "../../../surface/components/TootMediaFrame/TootMediaFrame";
import type { ITootHeroCenteredProps } from "./TootHeroCentered.props";

export const TootHeroCentered = ({
  alignment,
  anchorId,
  buttons,
  eyebrow,
  heading,
  image,
  parentClass,
  priority,
  spacing,
  subheading,
}: ITootHeroCenteredProps) => {
  const headingAlignment = alignment ?? "center";

  return (
    <TootSectionShell
      className="relative mx-auto grid w-full items-start justify-items-center gap-10 overflow-hidden md:place-items-center"
      id={anchorId ?? undefined}
      rootClassName={parentClass}
      spacing={spacing ?? undefined}
      tone="accent"
      width="full"
    >
      <div className="relative z-10 w-full">
        <div
          className={cn(
            "mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 sm:px-6 lg:px-8",
            headingAlignment === "center" ? "items-center text-center" : "items-start text-left",
          )}
        >
          <TootHeading
            actions={
              buttons?.length ? (
                <TootActions actions={buttons} alignment={headingAlignment} />
              ) : null
            }
            alignment={headingAlignment}
            as="h1"
            eyebrow={eyebrow}
            heading={heading}
            size="hero"
            subheading={subheading}
          />
        </div>
      </div>
      {image ? (
        <div className="relative z-10 w-full max-w-5xl px-4 sm:px-6 lg:px-8">
          <TootMediaFrame
            alt={image.alternateText}
            aspectRatio="16 / 10"
            caption={image.caption}
            className="shadow-2xl shadow-red-950/40"
            focalPoint={image.focalPoint ?? undefined}
            height={image.height ?? undefined}
            loading={priority ? "eager" : "lazy"}
            sizes={image.sizes ?? "(min-width: 1024px) 50vw, 100vw"}
            src={image.defaultSrc}
            srcSet={image.srcSet ?? undefined}
            width={image.width ?? undefined}
          />
        </div>
      ) : null}
    </TootSectionShell>
  );
};

TootHeroCentered.displayName = "Content::TootHeroCentered";
